export default __webpack_public_path__ + "static/media/iconCardUsers.f9c8eac4.svg";